<template>
    <section>
        <div class="legend"><b-icon icon="search"></b-icon> ประเภทสินค้า</div>

        <div class="form" v-if="formSearch">
            <div class="row mb-3">
                <div class="col">
                    <div class="field">
                        <dropdown
                            v-model="formSearch.productCategory"
                            placeholder="-- ประเภทสินค้า --"
                            :options="option.productCategory"
                            :classes="{ input: 'input-field' }"
                            @change="resetFormSearch()"
                        ></dropdown>
                    </div>
                </div>
            </div>

            <div class="filter mb-3" v-show="formSearch.productCategory && isShowFilter">
                <div class="row">
                    <div class="col">
                        <div class="field">
                            <input type="text" v-model="formSearch.keyword" class="input-field" placeholder="พิมพ์ชื่อรุ่น/ยี่ห้อ" />
                        </div>
                    </div>
                </div>
                <div class="row" v-show="formSearch.productCategory === $Constants.CATEGORY_TIRE">
                    <div class="col">
                        <div class="row input-tire-size">
                            <div class="col">
                                <div class="field">
                                    <dropdown
                                        v-model="formSearch.tireSizeW"
                                        placeholder="W"
                                        :options="option.tireSizeW"
                                        :classes="{ input: 'input-field' }"
                                        @change="loadTireRatio($event)"
                                    ></dropdown>
                                </div>
                            </div>
                            <div class="col">
                                <div class="field">
                                    <dropdown
                                        v-model="formSearch.tireSizeR"
                                        placeholder="R"
                                        :options="option.tireSizeR"
                                        :classes="{ input: 'input-field' }"
                                        @change="loadTireDiameter($event)"
                                    ></dropdown>
                                </div>
                            </div>
                            <div class="col">
                                <div class="field">
                                    <dropdown
                                        v-model="formSearch.tireSizeD"
                                        placeholder="D"
                                        :options="option.tireSizeD"
                                        :classes="{ input: 'input-field' }"
                                    ></dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-show="formSearch.productCategory === $Constants.CATEGORY_ENGINE">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <dropdown
                                v-model="formSearch.engineOilType"
                                placeholder="-- ประเภทน้ำมันเครื่อง --"
                                :options="option.engineOilType"
                                :classes="{ input: 'input-field' }"
                            ></dropdown>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-main" @click="searchProduct()">ค้นหา</button>
                </div>
            </div>
        </div>

        <loader-spinner :isDisplay="isLoading"></loader-spinner>

        <div class="result" v-if="isShowResult">
            <div class="text-center mb-3">
                <button class="btn btn-grey-outline" @click="backToSearch()">กลับไปค้นหาอีกครั้ง</button>
            </div>
            
            <template v-if="searchResult.length > 0">
                <perfect-scrollbar class="mb-3">
                    <table>
                        <thead>
                            <tr>
                                <th>รุ่นสินค้า</th>
                                <th>แบรนด์</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in searchResult" :key="index">
                                <td>{{ item.name }}</td>
                                <td>{{ item.brand }}</td>
                                <td class="text-center">
                                    <button class="btn btn-sm btn-blue text-nowrap" v-if="!item.isExist" @click="selectProduct(item.data)">เลือก</button>
                                    <span class="text-danger text-nowrap" v-if="item.isExist && mode === 'inventory'">มีในร้านแล้ว</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </perfect-scrollbar>

                <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="searchResult.length" class="mt-4"></paging>
            </template>

            <template v-if="searchResult.length === 0">
                <div class="form no-result filter" v-if="formTyping && errorData">
                    <div class="no-data">
                        <b-icon icon="exclamation-diamond"></b-icon>
                        <span>ไม่พบสินค้าในฐานข้อมูล โปรดทำการระบุชื่อรุ่นและแบรนด์สินค้าลงในฟอร์มด้านล่าง</span>
                    </div>

                    <div class="row">
                        <div class="col col-sm-12" :class="{ 'col-md-4': formSearch.productCategory === $Constants.CATEGORY_TIRE, 'col-md-6': formSearch.productCategory !== $Constants.CATEGORY_TIRE }">
                            <div class="field">
                                <input type="text"
                                        v-model="formTyping.brand"
                                        class="input-field"
                                        :class="{ 'invalid': errorData.brand.blank }"
                                        maxlength="100"
                                        placeholder="แบรนด์" />
                                <div class="input-error-message" v-if="errorData.brand.blank">โปรดกรอกแบรนด์สินค้า</div>
                            </div>
                        </div>
                        <div class="col col-sm-12" :class="{ 'col-md-4': formSearch.productCategory === $Constants.CATEGORY_TIRE, 'col-md-6': formSearch.productCategory !== $Constants.CATEGORY_TIRE }">
                            <div class="field">
                                <input type="text"
                                        v-model="formTyping.name"
                                        class="input-field"
                                        :class="{ 'invalid': errorData.name.blank }"
                                        maxlength="100"
                                        placeholder="รุ่นสินค้า" />
                                <div class="input-error-message" v-if="errorData.name.blank">โปรดกรอกชื่อรุ่นสินค้า</div>
                            </div>
                        </div>
                        <div class="col col-sm-12" :class="{ 'col-md-4': formSearch.productCategory === $Constants.CATEGORY_TIRE, 'col-md-6': formSearch.productCategory !== $Constants.CATEGORY_TIRE }">
                            <div class="field">
                                <input type="text"
                                    v-model="formTyping.size"
                                    v-if="formSearch.productCategory === $Constants.CATEGORY_TIRE"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.size.blank }"
                                    maxlength="20"
                                    placeholder="ขนาดยาง" />
                                <div class="input-error-message" v-if="errorData.size.blank">โปรดใส่ขนาดยาง</div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3 text-center">
                        <button class="btn btn-main" @click="submitFormTyping()">ส่งข้อมูล</button>
                    </div>
                </div>
            </template>
        </div>
    </section>
</template>

<script>
import OptionProductCategory from '@/database/staticOption/ProductCategory';
import OptionEngineOilType from '@/database/staticOption/EngineOilType';
import DBMasterProduct from '@/database/MasterProduct';
import DBInventory from '@/database/Inventory';
import ModelProductLookupFilter from '@/resources/models/ProductLookupFilter';

export default {
    data() {
        return {
            formSearch: null,
            formTyping: null,
            errorData: null,
            isShowFilter: true,
            isShowResult: false,
            isLoading: false,
            searchResult: [],
            activePage: 1,
            pageSize: 10,
            option: {
                productCategory: [],
                tireSizeW: [],
                tireSizeR: [],
                tireSizeD: [],
                engineOilType: []
            }
        };
    },
    props: {
        mode: {
            type: String,
            required: false,
            default: () => 'inventory'
        }
    },
    mounted() {
        this.initOptionData();
        this.formSearch = this.initFormLookup();
        this.formTyping = this.initFormTyping();
        this.errorData = this.initValidateData();
    },
    methods: {
        initFormLookup() {
            return ModelProductLookupFilter.data();
        },
        initFormTyping() {
            return {
                key: 0,
                name: '',
                brand: '',
                size: '',
                productCategory: '',
                engineOilType: ''
            };
        },
        async initOptionData() {
            this.option.productCategory = OptionProductCategory.option;

            this.option.tireSizeW = await this.$AppUtility.setupTireSizeWidthOption();
            this.option.tireSizeR = [];
            this.option.tireSizeD = [];

            this.option.engineOilType = OptionEngineOilType.option;
        },
        initValidateData() {
            return {
                name: { blank: false },
                brand: { blank: false },
                size: { blank: false }
            }
        },
        resetFormSearch() {
            this.formSearch.keyword = '';
            this.formSearch.tireSizeW = '';
            this.formSearch.tireSizeR = '';
            this.formSearch.tireSizeD = '';
            this.formSearch.engineOilType = '';
        },
        async loadTireRatio(value) {
            this.formSearch.tireSizeR = '';
            this.formSearch.tireSizeD = '';

            if (value) {
                const param = {
                    width: value
                };

                this.option.tireSizeR = await this.$AppUtility.setupTireSizeRatioOption(param);
            }
        },
        async loadTireDiameter(value) {

            if (value) {
                const param = { 
                    width: this.formSearch.tireSizeW,
                    ratio: value
                };

                this.option.tireSizeD = await this.$AppUtility.setupTireSizeDiameterOption(param);
            }
        },
        filterResult(result) {
            if (this.formSearch.productCategory) {
                result = result.filter(x => x.productCategory === this.formSearch.productCategory);
            }
            if (this.formSearch.keyword) {
                result = result.filter(x => x.name?.toLowerCase().indexOf(this.formSearch.keyword.toLowerCase()) > -1 
                                            || x.brand?.toLowerCase().indexOf(this.formSearch.keyword.toLowerCase()) > -1)
            }
            if (this.formSearch.tireSizeW || this.formSearch.tireSizeR || this.formSearch.tireSizeD) {
                let tireSizeFilter = this.$AppUtility.getTireSizeList(this.formSearch.tireSizeW, this.formSearch.tireSizeR, this.formSearch.tireSizeD);
                
                result = result.filter(x => { return this.$AppUtility.findStartWithResult(tireSizeFilter, x.size); });
            }
            if (this.formSearch.engineOilType) {
                result = result.filter(x => x.oilType === this.formSearch.engineOilType);
            }

            return result;
        },
        async searchProduct() {
            this.isLoading = true;
            this.isShowFilter = false;
            this.searchResult = [];

            // Sync Master Data
            await DBMasterProduct.sync();

            // Load Master Data
            const result = await DBMasterProduct.get();

            if (result.content && result.content.length > 0) {
                // Filter Result
                result.content = this.filterResult(result.content);

                // Map and Place into the Object
                this.searchResult = await this.mapViewData(result.content);
            }

            // Clear Loading
            this.isLoading = false;
            this.isShowResult = true;
        },
        async mapViewData(content) {
            const data = [];
            const inventoryList = await DBInventory.get();
            
            content.forEach((item) => {
                data.push({
                    name: item.name,
                    brand: item.brand,
                    isExist: this.detectInventoryExist(item, inventoryList.content),
                    data: item
                });
             });

            return data;
        },
        detectInventoryExist(item, inventoryList) {
            let isExist = false;

            if (inventoryList.filter(x => x.productData.masterProductKey === item.key).length > 0) {
                isExist = true;
            }

            return isExist;
        },
        backToSearch() {
            this.isShowFilter = true;
            this.isShowResult = false;
        },
        submitFormTyping() {
            if (this.validateData()) {
                this.formTyping.productCategory = this.formSearch.productCategory;

                this.selectProduct(this.formTyping);
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formTyping[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        },
        selectProduct(data) {
            this.$emit('selectedProduct', data);
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.legend {
    font-size: 12px;
    margin-bottom: 7px;
    color: $textSecondaryColor;

    .bi {
        margin-right: 5px;
        opacity: 0.6;
    }
}

.no-result {
    .row {
        margin-left: -5px;
        margin-right: -5px;

        .col {
            padding-right: 5px;
            padding-left: 5px;
        }
    }
}

table {
    font-size: 13px;
}
</style>